import Vue from "vue";
import VueRouter from "vue-router";
// import HowmeView from "../views/HomeView.vue";
import WaitView from "../views/WaitView.vue";
import Under18View from "../views/under18View.vue";
import ProductsView from "../views/ProductsView.vue";
//import FormView from "../views/FormView.vue";
//import GameView from "../views/GameView.vue";
//import ContactView from "../views/ContactView.vue";
import NotFoundView from "../views/NotFoundView.vue";
import MentionsView from "../views/MentionsView.vue";
import FinishView from "../views/FinishView.vue";

Vue.use(VueRouter);

// Composant dynamique qui gère le changement à minuit
const DynamicHomeComponent = {
  data() {
    return {
      isAfterMidnight: false
    }
  },
  created() {
    this.checkMidnight();
    // Vérifier toutes les minutes
    this.interval = setInterval(this.checkMidnight, 60000);
  },
  beforeDestroy() {
    // Nettoyer l'intervalle quand le composant est détruit
    clearInterval(this.interval);
  },
  methods: {

      checkMidnight() {
        const now = new Date();
        const startDate = new Date('2025-05-19T00:00:00');
        this.isAfterMidnight = now >= startDate;
      }
  },
  render(h) {
    return h(this.isAfterMidnight ? FinishView : WaitView);
  }
};


const routes = [
  {
    path: "/",
    name: "under18",
    component: Under18View,
  },
  {
    path: "/home",
    name: "home",
    component: DynamicHomeComponent,
  },
  {
    path: "/mentions",
    name: "mentions",
    component: MentionsView,
  },
  {
    path: "/home2",
    name: "home2",
    component: FinishView ,
  },
  {
    path: "/products",
    name: "products",
    component: ProductsView,
  },
  {
    path: "/form",
    name: "form",
    component: FinishView ,
  },
  {
    path: "/game",
    name: "game",
    component: FinishView ,
  },
  {
    path: "/wait",
    name: "wait",
    component: WaitView,
  },
  {
    path: "/contact",
    name: "contact",
    component: FinishView ,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: NotFoundView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
